import { APP_DATE_FORMAT_EXPANDED } from "@/config/constants";
import { IEdoCourseMaterial } from "@/shared/model/edo-course-material.model";
import { Card, Badge, ListItem, ListItemIcon, ListItemText } from "@/components/ui";
import { BookOpen } from "lucide-react";
import { TextFormat } from "react-jhipster";
import { useNavigate } from "react-router-dom";

interface ICourseMaterialProps {
  courseMaterial: IEdoCourseMaterial;
  compact?: boolean;
}

const CourseMaterial = (props: ICourseMaterialProps) => {
  const navigate = useNavigate();
  const { courseMaterial, compact = false } = props;

  const handleOpenCourse = () => {
    navigate(`/courses/${courseMaterial.course.id}/materials`);
  };

  if (compact) {
    return (
      <ListItem
        className="flex cursor-pointer items-center gap-3 px-5 py-2.5 transition-colors hover:bg-primary/5"
        onClick={handleOpenCourse}
      >
        <ListItemIcon className="shrink-0">
          <div className="flex h-8 w-8 items-center justify-center rounded-3xl bg-primary/10 text-primary">
            <BookOpen className="h-4 w-4" />
          </div>
        </ListItemIcon>
        <ListItemText
          primary={
            <span className="text-sm font-medium text-[var(--color-mockup-text)] line-clamp-2">
              {courseMaterial.title}
            </span>
          }
          secondary={
            <span className="text-xs text-[var(--color-mockup-text-light)]">
              <TextFormat
                type="date"
                value={courseMaterial.createdAt}
                format={APP_DATE_FORMAT_EXPANDED}
                locale="it"
              />
            </span>
          }
        />
      </ListItem>
    );
  }

  return (
    <Card
      className="flex h-[85px] w-full cursor-pointer flex-row items-center justify-start overflow-hidden rounded-3xl border border-[var(--color-mockup-border)] shadow-card transition-all duration-200 hover:border-primary/40 hover:shadow-card-hover"
      onClick={handleOpenCourse}
    >
      <div className="flex h-full aspect-square shrink-0 items-center justify-center bg-primary/10 p-3 text-primary">
        <BookOpen className="h-6 w-6" />
      </div>
      <div className="flex min-w-0 flex-col justify-center p-4">
        <h2 className="flex items-center gap-2 truncate text-lg font-heading font-bold text-[var(--color-mockup-text)]">
          {courseMaterial.title}
          <Badge variant="secondary" className="shrink-0 text-xs">
            {courseMaterial.course.subject.name} - {courseMaterial.course.class.year.year}°
            {courseMaterial.course.class.section}
          </Badge>
        </h2>
        <span className="text-sm text-[var(--color-mockup-text-light)]">
          <TextFormat
            type="date"
            value={courseMaterial.createdAt}
            format={APP_DATE_FORMAT_EXPANDED}
            locale="it"
          />
        </span>
      </div>
    </Card>
  );
};

export default CourseMaterial;